module.exports = __webpack_public_path__ + "8bf3d6729db79c79c2b0d537bede88c9.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/bookmark.png
// module id = 1033
// module chunks = 23